const flowStepEnumerators = {
  type: ['form', 'action', 'validation', 'notification'],
  status: ['active', 'inactive', 'draft', 'archived'],
  actionType: ['email', 'sms', 'push', 'webhook'],
};

export default flowStepEnumerators;
